class GuideTrigger extends HTMLElement {
  constructor() {
    super();

    this.button = null;
    this.template = null;

    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector("button");
    this.template = this.querySelector(
      "template[data-guide-content]",
    );

    if (!this.button || !this.template) {
      return;
    }

    this.button.addEventListener(
      "click",
      this.handleClick,
    );
  }

  disconnectedCallback() {
    this.button?.removeEventListener(
      "click",
      this.handleClick,
    );
  }

  handleClick(event) {
    event.preventDefault();

    this.openModal(this.button);
  }

  openModal(sourceElement = this) {
    const html = this.getContent();

    if (!html) {
      console.warn("Guide content was not found.");
      return;
    }

    sourceElement.dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail: {
          target: this.modalTarget,
          html,
        },
      }),
    );

    document
      .getElementById(this.modalTarget)
      ?.querySelector("[data-guide-tab].is-active")
      ?.scrollIntoView({ inline: "nearest", block: "nearest" });
  }

  getContent() {
    if (!this.template) {
      return null;
    }

    return this.template.innerHTML.trim();
  }

  get modalTarget() {
    return (
      this.getAttribute("modal-target") ||
      "guide-modal"
    );
  }

}

if (!customElements.get("guide-trigger")) {
  customElements.define(
    "guide-trigger",
    GuideTrigger,
  );
}

if (!window.guideModalInteractionsInitialized) {
  window.guideModalInteractionsInitialized = true;

  document.addEventListener("click", (event) => {
    const tab = event.target.closest("[data-guide-tab]");

    if (tab) {
      const tabsContainer = tab.closest("[data-guide-tabs]");
      const selectedPanel = tab.dataset.guideTab;

      if (!tabsContainer || !selectedPanel) {
        return;
      }

      tabsContainer
        .querySelectorAll("[data-guide-tab]")
        .forEach((item) => {
          const isActive =
            item.dataset.guideTab === selectedPanel;

          item.classList.toggle("is-active", isActive);
          item.setAttribute(
            "aria-selected",
            String(isActive),
          );
        });

      tabsContainer
        .querySelectorAll("[data-guide-panel]")
        .forEach((panel) => {
          const isActive =
            panel.dataset.guidePanel === selectedPanel;

          panel.classList.toggle("is-active", isActive);
          panel.hidden = !isActive;
        });

      return;
    }

    const tableTab = event.target.closest("[data-table-tab]");

    if (tableTab) {
      const tableTabsContainer = tableTab.closest(
        "[data-table-tabs]",
      );
      const selectedPanel = tableTab.dataset.tableTab;

      if (!tableTabsContainer || !selectedPanel) {
        return;
      }

      tableTabsContainer
        .querySelectorAll("[data-table-tab]")
        .forEach((item) => {
          const isActive =
            item.dataset.tableTab === selectedPanel;

          item.classList.toggle("is-active", isActive);
          item.setAttribute(
            "aria-selected",
            String(isActive),
          );
        });

      tableTabsContainer
        .querySelectorAll("[data-table-panel]")
        .forEach((panel) => {
          const isActive =
            panel.dataset.tablePanel === selectedPanel;

          panel.classList.toggle("is-active", isActive);
          panel.hidden = !isActive;
        });

      return;
    }

    const unitButton = event.target.closest(
      "[data-measurement-unit]",
    );

    if (!unitButton) {
      return;
    }

    const units = unitButton.closest(
      "[data-measurement-units]",
    );

    const measurementsSection = unitButton.closest(
      ".guide-modal__measurements",
    );
    const selectedUnit =
      unitButton.dataset.measurementUnit;

    if (!units || !measurementsSection) {
      return;
    }

    units
      .querySelectorAll("[data-measurement-unit]")
      .forEach((button) => {
        const isActive =
          button.dataset.measurementUnit === selectedUnit;

        button.classList.toggle("is-active", isActive);
        button.setAttribute(
          "aria-pressed",
          String(isActive),
        );
      });

    measurementsSection
    .querySelectorAll("[data-measurement-value]")
    .forEach((cell) => {
      const inches = cell.dataset.inches ?? "";
      const centimeters = cell.dataset.centimeters;

      if (selectedUnit === "in") {
        cell.textContent = inches;
        return;
      }

      if (centimeters !== undefined) {
        cell.textContent = centimeters;
        return;
      }

      const numericInches = Number(inches);

      if (Number.isFinite(numericInches) && inches.trim() !== "") {
        cell.textContent = (numericInches * 2.54).toFixed(1);
        return;
      }

      cell.textContent = inches;
    });
  });
}